import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as fileSaver from 'file-saver';
import { ClientInvoice, ClientInvoiceRequest, DownloadClientInvoiceRequest, UserInfo } from '../helpers/interfaces';
import { ApiService } from '../services/api.service.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-monthly-invoices',
  templateUrl: './monthly-invoices.component.html',
  styleUrls: ['./monthly-invoices.component.css']
})
export class MonthlyInvoicesComponent implements OnInit {

  constructor(private apiService: ApiService, private userService: UserService) { }

  displayedColumns: string[] = ['ClientInvoiceID', 'InvoiceDate', 'AmountDue', 'AmountPaid', 'AmountUnpaid', 'invoice-action'];

  userInfo!: UserInfo;
  clientInvoices!: MatTableDataSource<ClientInvoice>;
  clientInvoiceRequest!: ClientInvoiceRequest;
  fileDownloading: boolean = false;

  @ViewChild('paginator')
  paginator!: MatPaginator;
  
  @ViewChild(MatSort)
  sort!: MatSort;
  
  ngOnInit(): void {
    this.userInfo = this.userService.userInfo;

    this.clientInvoiceRequest = {
      ClientId: this.userInfo.ClientId,
      PageIndex: 1,
      PageSize: 10000,
      RepId: 0,
      SortColumn: 'ClientInvoiceID',
      SortOrder: 'DESC'
    }

    this.apiService.makeStandardApiCall('values/GetClientInvoices', this.clientInvoiceRequest).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          this.clientInvoices = new MatTableDataSource<ClientInvoice>(JSON.parse(data.Value));
          this.clientInvoices.paginator = this.paginator;
          this.clientInvoices.sort = this.sort;
        }
      }
    );
  }

  downloadInvoice(InvoiceNumber: number): void {
    this.fileDownloading = true;
    const downloadRequest: DownloadClientInvoiceRequest = {
      ClientInvoiceID: InvoiceNumber
    }
    this.apiService.downloadClientInvoiceFile(downloadRequest).subscribe((response: any) => { //when you use stricter type checking
      // const blob = new Blob([response], { type: 'application/octet-stream' });
      // const url= window.URL.createObjectURL(blob);
      // window.open(url);
      let blob: any = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      let reportName = 'ClientInvoice';
      fileSaver.saveAs(blob, reportName + '.xlsx');
      this.fileDownloading = false;
    }), (error: any) => this.fileDownloading = false, console.log('Error downloading the file'), //when you use stricter type checking
      () => console.info('File downloaded successfully');
  }
}
